var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showLoading)?_c('div',{staticClass:"loading-box"},[_c('a-spin',{attrs:{"tip":"Loading..."}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }